<template>
  <div id="rootContainer">
    <div class="css_container" id="css_container" v-if="legends.length>0" style="max-height: 500px; overflow-y: scroll;">
      <el-col style="padding-top: 10px;">
        <el-row style="text-align: left;font-weight: bold;font-size: 14px; height: 40px;line-height: 19px;">
          <div v-html="title_parse(title)"></div>
        </el-row>

        <el-row v-for="(item,index) in legends" v-show="item.label=='mv'?false:true" :key="index">
          <el-col :span="20" class="cell_col_0" style="display: flex;flex-direction: row; background-color: transparent; overflow: hidden;">
            <div class="cell_tile"  :style="{backgroundColor:item.color}"></div> {{legendValue_parse(item.label)}}
          </el-col>
          <el-col :span="4" class="cell_col_1" style="background-color:transparent">
            <el-color-picker v-model="item.color"  size="mini" style="border: none;" @change="activeChange"></el-color-picker>
          </el-col>
        </el-row>

      </el-col>
    </div>
  </div>
</template>

<script>

let legend_shousuo =  require( '../../../assets/icons/icon_shousuo.png');
export default {
  name: "MapLengend",
  props:{
    title:{
      type:String,
      required: false,
      default:function (){
        return "Legend";
      }
    },
    legends:{
      type: Array,
      required:false,
      default:function () {
        return [
        ];
      }
    }
  },
  data(){
    return {
      layout_model:0,
      color1: '#409EFF',
      icon_legend_shousuo:legend_shousuo,
      cell_h:26,
      cell_header:40
    }
  },mounted() {
    this.updateHeight();
  },
  methods:{
    legendValue_parse(label){
      //console.log(" ");
      //console.log("label = ",label);
      label = label.trim();

      //已经人工校对过了，过滤掉
      if(label.indexOf("~")>0){
        return label;
      }

      let num_hyphen =0;

      for(let i=0;i<label.length;i++){
        let label_char = label[i];
        if(label_char=="-"){
          num_hyphen = num_hyphen+1;
        }
      }
      if(num_hyphen<2){
        return label;
      }


      let hyphen_index = undefined;
      let label_new = new Array();
      if(num_hyphen==2){
       //说明有赋值
        if(label.indexOf("-")==0){
          hyphen_index = 2;
        }else {
          hyphen_index = 1;
        }
      }else if(num_hyphen==3){
        hyphen_index = 2;
      }

      if(num_hyphen>1){
        let cur_hyphen_index = 0;
        for(let i=0;i<label.length;i++){
          let label_char = label[i];
          console.log("index = ",i," & value = ",label_char);
          if(label_char=="-"){
            cur_hyphen_index = cur_hyphen_index+1;
            if(cur_hyphen_index==hyphen_index){
              label_char="~";
            }
          }
          label_new.push(label_char);
        }
      }

      let label_out =  label_new.join("");
      return label_out.trim();
    },

    //更新标题
    title_parse(title){
      //return title;
      //return "GDP Loss (10" +"10".sup()+"USD)";
      //  "GDP_LOSS_RISK_FLOOD_RISK_GDP_FLD_2000S_S0_VALUE_MME_GLOBAL": "GDP Loss (#10-4# USD)",
      let titles = title.split("#");
      let lendend_title = "";
      for(let i=0;i<titles.length;i++){
        let item = titles[i];
        if(item.indexOf("^")>-1){
          lendend_title = lendend_title+item.split("^")[0]+(item.split("^")[1]).sup();
        }else {
          lendend_title = lendend_title+item;
        }
      }
      return lendend_title;
    },

    updateHeight_cropsRisk(){
      console.log("updateHeight && this.legends = ",this.legends);

      //科学计数校对
      if(this.legends!=null && this.legends.length>0){
        let legend_height = this.legends.length *  this.cell_h +this.cell_header;
        legend_height = legend_height+15;
        document.getElementById("css_container").style.height  = legend_height + "px";
      }
    },

    updateHeight(){
      console.log("updateHeight && this.legends = ",this.legends);
      if(this.legends!=null && this.legends.length>0){
        //alert("updateHeight");
        let legend_height = this.legends.length *  this.cell_h +this.cell_header;
        legend_height = legend_height+17;
        document.getElementById("css_container").style.height  = legend_height + "px";
      }
    },
    layout_update(){
      let obj = document.getElementById("css_container");
      let obj_height = obj.style.height;
      obj_height = obj_height.substr(0,obj_height.indexOf("px") );
      this.$emit("layoutupdate",obj_height);

      if (this.layout_model==0){
        this.layout_model==1;
      }
    },

    activeChange(){
      console.log("colos picker = ",this.legends);
      this.$emit("colorsChanged",this.legends);
    }
  }

}
</script>

<style scoped>

::-webkit-scrollbar {display:none}

.css_container{
  background-color:white;
  width: 220px;
  min-height: 125px;
  padding-left: 10px;
  padding-right: 10px;
  border: solid 1px lightgrey;
  border-radius: 3px;
}

.css_title{
  background-color: transparent;
  text-align: left;
  font-size: 17px;
  margin-bottom: 10px;
}

.cell_tile{
  width: 18px;
  height: 18px;
  margin-top: 3px;
  margin-right: 5px;
  border: 1px solid lightgrey;
  border-radius: 3px;
}
.cell_col_0 {
  text-align: left;
  font-size: 14px;
  height: 25px;
  line-height: 25px;
}
.cell_col_1
{
  text-align: right;
  font-size: 14px;
  height: 25px;
  line-height: 25px;
}
</style>



// WEBPACK FOOTER //
// src/view/BSD/components/MapLengend.vue